export default "__VITE_ASSET__CzqBm3nK__"